import React, { useMemo } from 'react';
import Form from '@/common/components/Form/index';
import DataEntryForm from '@/common/containers/FormConstructor/components/DataEntryForm';
import { isSaleProceedsField } from '@/common/containers/Forms/final-disposition.utils';

const FinalDispositionForm = ({
  question,
  answers = [],
  hideSaleProceeds = false,
  ...props
}) => {
  const visibleQuestion = useMemo(() => {
    if (!hideSaleProceeds || !question?.properties) {
      return question;
    }

    return {
      ...question,
      properties: question.properties.filter(
        (property) => !isSaleProceedsField(property)
      ),
    };
  }, [hideSaleProceeds, question]);

  return (
    <Form
      initialValues={
        answers.length ? answers[0].value : { dispDate: new Date() }
      }
      {...props}
    >
      <DataEntryForm {...visibleQuestion} header={undefined} />
    </Form>
  );
};

export default FinalDispositionForm;
